module.exports = __webpack_public_path__ + "static/media/explore-step2-img.21286603.png";